export default {
  state: {
    assetContents: [],
    assetNodes: [],
    assetSelectedDeliverable: {},
    assetSelectedFamily: {},
    assetSelectedMessageInList: {},
    assetSelectedNode: {},
    assetSelectedStudent: {},
    assetSelectedTask: {},
    assetSelectedTaskInList: {}
  },

  getters: {
    getAssetContents (state) {
      return state.assetContents
    },

    getAssetNodes (state) {
      return state.assetNodes
    },

    getAssetSelectedDeliverable (state) {
      return state.assetSelectedDeliverable
    },

    getAssetSelectedFamily (state) {
      return state.assetSelectedFamily
    },

    getAssetSelectedMessageInList (state) {
      return state.assetSelectedMessageInList
    },

    getAssetSelectedNode (state) {
      return state.assetSelectedNode
    },

    getAssetSelectedStudent (state) {
      return state.assetSelectedStudent
    },

    getAssetSelectedTask (state) {
      return state.assetSelectedTask
    },

    getAssetSelectedTaskInList (state) {
      return state.assetSelectedTaskInList
    }
  },

  mutations: {
    setAssetContents (state, assetContents) {
      state.assetContents = assetContents
    },

    setAssetNodes (state, assetNodes) {
      state.assetNodes = assetNodes
    },

    setAssetSelectedDeliverable (state, assetSelectedDeliverable) {
      state.assetSelectedDeliverable = assetSelectedDeliverable
    },

    setAssetSelectedFamily (state, assetSelectedFamily) {
      state.assetSelectedFamily = assetSelectedFamily
    },

    setAssetSelectedMessageInList (state, assetSelectedMessageInList) {
      state.assetSelectedMessageInList = assetSelectedMessageInList
    },

    setAssetSelectedNode (state, assetSelectedNode) {
      state.assetSelectedNode = assetSelectedNode
    },

    setAssetSelectedStudent (state, assetSelectedStudent) {
      state.assetSelectedStudent = assetSelectedStudent
    },

    setAssetSelectedTask (state, assetSelectedTask) {
      state.assetSelectedTask = assetSelectedTask
    },

    setAssetSelectedTaskInList (state, assetSelectedTaskInList) {
      state.assetSelectedTaskInList = assetSelectedTaskInList
    },

    unsetAssetContents (state) {
      state.assetContents = []
    },

    unsetAssetNodes (state) {
      state.assetNodes = []
    },

    unsetAssetSelectedDeliverable (state) {
      state.assetSelectedDeliverable = {}
    },

    unsetAssetSelectedMessageInList (state) {
      state.assetSelectedMessageInList = {}
    },

    unsetAssetSelectedNode (state) {
      state.assetSelectedNode = {}
    },

    unsetAssetSelectedStudent (state) {
      state.assetSelectedStudent = {}
    },

    unsetAssetSelectedTask (state) {
      state.assetSelectedTask = {}
    },

    unsetAssetSelectedTaskInList (state) {
      state.assetSelectedTaskInList = {}
    }
  }
}
